<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title">用户管理</li>
      <el-button
        type="primary"
        :icon="Plus"
        link
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
        v-if="$judge_auth('161')"
        >添加
      </el-button>
    </ul>
    <div class="tree-box" style="margin-top: 10px">
      <div class="tree-box-tree">
        <ul>
          <li class="admin-list-tree-title">部门</li>
          <el-button
            link
            title="刷新"
            size="small"
            :class="state.departmentData ? '' : 'refresh-rotate'"
            @click="onLoadDepartment"
          >
            <template #icon>
              <el-icon style="font-weight: 600" color="#a2a2a2" :size="16"
                ><Refresh
              /></el-icon>
            </template>
          </el-button>
        </ul>
        <div style="flex: 1; overflow: auto; padding-right: 10px">
          <el-tree
            :data="[{ name: '远创发薪系统', children: state.departmentData }]"
            node-key="id"
            :props="{ label: 'name', children: 'children' }"
            default-expand-all
            :expand-on-click-node="false"
            style="width: fit-content"
            @node-click="onDepartmentClick"
          />
        </div>
      </div>
      <div class="tree-box-content">
        <ul class="tree-box-content-search">
          <el-space wrap style="flex: 1">
            <el-input
              v-model="state.params.name"
              style="width: 200px"
              placeholder="--关键字--"
              clearable
              @clear="
                delete state.params.name;
                onLoad();
              "
            ></el-input>
            <el-dropdown split-button @click="onLoad" type="primary">
              查询
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                    重置
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </el-space>
        </ul>
        <div class="tree-box-content-table">
          <el-table
            :data="state.tableData"
            v-loading="!Array.isArray(state.tableData)"
            element-loading-background="rgba(0, 0, 0, 0.2)"
            :default-sort="{
              prop: state.params.sort_field,
              order:
                state.params.sort_value == 'desc' ? 'descending' : 'ascending',
            }"
            @sort-change="onSortChange"
          >
            <el-table-column
              fixed
              label="序号"
              width="50"
              type="index"
              :index="
                (index) =>
                  (state.params.page - 1) * state.params.limit + index + 1
              "
              align="center"
            />
            <el-table-column
              label="状态"
              prop="status"
              sortable="status"
              width="100"
              fixed="left"
            >
              <template #default="{ row }">
                <el-switch
                  v-model="row.status"
                  inline-prompt
                  active-text="启用"
                  active-color="#1e90ff"
                  inactive-text="停用"
                  inactive-color="#f00"
                  :active-value="1"
                  :inactive-value="0"
                  style="--el-switch-off-color: #f00"
                  @change="onChangeQt(row)"
                  :disabled="!$judge_auth('164')"
                />
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              sortable="name"
              label="姓名"
              :formatter="
                (row, column, cellValue) =>
                  $tab_Highlinght(cellValue, state.params.keywords)
              "
              min-width="120"
            />
            <el-table-column
              prop="phone"
              label="手机号"
              :formatter="$tab_TextFormat"
              min-width="120"
            />

            <el-table-column
              prop="department_name"
              label="所属部门"
              :formatter="$tab_TextFormat"
              min-width="120"
            />
            <el-table-column
              prop="admin_role_name"
              label="角色"
              :formatter="$tab_TextFormat"
              min-width="160"
              show-overflow-tooltip
            />
            <el-table-column
              prop="email"
              label="邮箱"
              :formatter="$tab_TextFormat"
              min-width="120"
            />
            <el-table-column
              prop="job"
              label="职务"
              :formatter="$tab_TextFormat"
              min-width="120"
            />
            <el-table-column
              prop="create_time"
              sortable="create_time"
              label="创建时间"
              width="180"
            />
            <el-table-column
              prop="update_time"
              sortable="update_time"
              label="修改时间"
              width="180"
            />
            <el-table-column
              label="操作"
              width="260"
              align="center"
              fixed="right"
              className="tabBtn"
              v-if="$judge_auth(['162', '163', '165'])"
            >
              <template #default="{ row }">
                <el-button
                  type="primary"
                  link
                  icon="Edit"
                  @click="
                    state.selectId = row.id;
                    state.showInfo = true;
                  "
                  :title="row.id"
                  v-if="$judge_auth('162')"
                >
                  编辑
                </el-button>
                <el-button
                  type="primary"
                  link
                  icon="Refresh"
                  :title="row.id"
                  @click="onResetPass(row)"
                  v-if="$judge_auth('165')"
                >
                  密码重置
                </el-button>
                <el-button
                  type="danger"
                  link
                  icon="Delete"
                  :title="row.id"
                  @click="onDelete(row.id)"
                  v-if="$judge_auth('163')"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <c_page
            :total="state.totalCount"
            :pageIndex="state.params.page"
            :pageSize="state.params.limit"
            @onLoad="
              (page) => {
                state.params.page = page.pageIndex;
                state.params.limit = page.pageSize;
                onLoad();
              }
            "
          />
        </div>
      </div>
    </div>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showInfo"
        :title="(state.selectId ? '修改' : '添加') + '用户'"
        @close="state.showInfo = false"
      >
        <c_AdminInfo
          @close="
            state.showInfo = false;
            onLoad();
          "
          :id="state.selectId"
        ></c_AdminInfo>
      </c_popup>
    </transition>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showYh"
        title="绑定用户"
        @close="state.showYh = false"
      >
        <c_AdminBindYh
          @close="
            state.showYh = false;
            onLoad();
          "
          :id="state.selectId"
        ></c_AdminBindYh>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  admin_list,
  admin_delete,
  admin_resetpass,
  admin_qt,
} from "@/http/admin";
import { data_department_tree } from "@/http/data";
import { ElMessageBox, ElMessage } from "element-plus";
import { confirm_func } from "@/utils/qFormat";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
    sort_field: "create_time",
    sort_value: "desc",
    name: "",
  };
}
export default {
  setup() {
    const state = reactive(new InitFormData());
    onMounted(() => {
      onLoadDepartment();
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      admin_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    const onLoadDepartment = () => {
      delete state.departmentData;
      data_department_tree().then((res) => {
        if (res.status == 200) state.departmentData = res.data.data;
      });
    };

    const onDepartmentClick = (row) => {
      state.params.department_id = row.id;
      state.params.page = 1;
      onLoad();
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    //重置密码
    const onResetPass = (row) => {
      ElMessageBox.confirm(
        `您确定<strong style='color:#f00'>重置</strong>用户<strong style='color:#080'>${row.name}</strong>的登录密码？`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        admin_resetpass(row).then((res) => {
          if (res.status == 200)
            ElMessage({
              type: "success",
              grouping: true,
              message: res.data.msg,
            });
        });
      });
    };

    //启停
    const onChangeQt = (row) => {
      ElMessageBox.confirm(
        `您确定${
          row.status == 0
            ? '<strong style="color:#f00">停用'
            : '<strong style="color:#1e90ff">启用'
        }</strong>该用户吗？`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          admin_qt(row).then((res) => {
            if (res.status == 200)
              ElMessage({
                type: "success",
                grouping: true,
                message: res.data.msg,
              });
          });
        })
        .catch(() => {
          row.status = row.status == 1 ? 0 : 1;
        });
    };

    //配置权限
    const onShowAuthorize = (id) => {
      state.key = Math.random();
      state.showQx = true;
      state.selectId = id;
    };

    //删除
    const onDelete = (id) => {
      confirm_func(admin_delete, id, onLoad);
    };

    return {
      state,
      onLoadDepartment,
      onLoad,
      onSortChange,
      onReset,
      onChangeQt,
      onShowAuthorize,
      onDelete,
      onDepartmentClick,
      onResetPass,
    };
  },
};
</script>
<style scoped lang="less">
.admin-list-tree-title {
  position: relative;
  padding-left: 7px;
  font-size: 13px;
  color: #a2a2a2;
  flex: 1;
  &::after {
    content: "";
    width: 3px;
    background-color: #1e90ff;
    border-radius: 10px;
    height: 70%;
    top: 15%;
    position: absolute;
    left: 0;
  }
}

.refresh-rotate {
  animation: fadenum 2s linear infinite;
}

@keyframes fadenum {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
